<template>
<div class="hero">
  <h1 class="ut-font-medium ut-pt-8 ut-pb-2 md:ut-pt-12">{{this.headline}}</h1>

  <p class="ut-p-2 md:ut-text-xl">See your list of local agents in your area, or&nbsp;let&nbsp;us&nbsp;recommend&nbsp;the&nbsp;best&nbsp;3&nbsp;for&nbsp;you</p>

  <router-link :to="{name: 'shortlist'}" v-gaEvent="{ category: gacategory, action: 'Click Get Personalised Shortlist', label: 'Header'}" class="ut-oa-btn ut-mt-4">Get your personalised shortlist
  </router-link>

</div>
</template>

<script>
import headlineHelpers from '../helpers/headline-helpers';

export default {
  name: 'Hero',
  props: {
    suburbname: null,
  },
  data() {
    return {
      gacategory: "Directory with smart search",
      headline: null,
    };
  },
  created() {
    this.headline = headlineHelpers.getHeadline(this.suburbname, this.$store.state.query.hl);
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.hero {
    background: linear-gradient(rgba(0, 0, 0, 0.50), rgba(0, 0, 0, 0.50)),url('../assets/images/herobg.jpg');
    @apply ut-text-center ut-p-4 ut-pb-20 ut-text-N0 ut-bg-center ut-bg-no-repeat bg-cover;

    @screen md {
        @apply ut-pb-24;
    }

    h1 {
        font-size: 28px;

        @screen lg {
            font-size: 40px;
        }
    }
}
</style>
